import { enGB, nl, fr, de } from 'date-fns/locale'
import type { Locale } from 'date-fns'
import { format } from 'date-fns'

/**
 * Maps locale codes to date-fns locale objects
 */
const locales: Record<string, Locale> = {
  en: enGB,
  nl: nl,
  fr: fr,
  de: de
}

/**
 * Gets the date-fns locale object for the specified locale code
 * Falls back to enGB if the locale is not supported
 */
export function getDateLocale(localeCode: string): Locale {
  return locales[localeCode] || enGB
}

/**
 * Gets localized day names using date-fns
 * Returns an array of objects with long and short day names
 * Short names are exactly 2 characters and the week starts with Monday
 */
export function getLocalizedDayNames(locale: Locale) {
  return Array.from({ length: 7 }, (_, i) => {
    // Start with Monday (1) as first day of week for the calendar
    const date = new Date(2021, 0, 4 + i) // Jan 4, 2021 was a Monday
    return {
      long: format(date, 'EEEE', { locale }), // Full name (e.g., "Monday")
      short: format(date, 'EEEEEE', { locale }).substring(0, 2)  // Exactly 2 letters
    }
  })
} 